import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useUpdateSearchUrlParams } from 'b2b-apps/shop/catalog/hooks/index';
import { PaginationFiltersType } from 'b2b-apps/shop/catalog/redux/search/types';
import { FILTERS } from 'b2b-apps/shop/catalog/utils/facets';
import { getPaginationFilters } from 'b2b-apps/shop/catalog/utils/filters';
import { useDeviceType } from 'b2b-apps/shop/common/hooks';
import { useCatalogSettingsActions, useCatalogSettingsData } from 'b2b-apps/shop/settings/hooks';


type UseCatalogPaginationFiltersReturnType = {
  paginationFilters: PaginationFiltersType;
  handlePaginationPageChange: (page: number) => void;
  handlePageSizeChange: (pageSize: number) => void;
  handleSortingChange: (sorting: string) => void;
};
export const useCatalogPaginationFilters = (): UseCatalogPaginationFiltersReturnType => {
  const { search } = useLocation();
  const { pageSize, sorting } = useCatalogSettingsData();
  const { updateSearchUrlParams } = useUpdateSearchUrlParams();
  const { changeSorting, changePageSize } = useCatalogSettingsActions();
  const deviceType = useDeviceType();

  const paginationFilters: PaginationFiltersType = useMemo(
    () => getPaginationFilters(search, deviceType, pageSize, sorting), [search, deviceType, pageSize, sorting],
  );

  const handlePaginationPageChange = (page: number): void => {
    const updatedFilters: PaginationFiltersType = {
      ...paginationFilters,
      page,
    };

    updateSearchUrlParams({ [FILTERS.pagination]: updatedFilters });
  };

  const handlePageSizeChange = (pageSize: number): void => {
    const updatedFilters: PaginationFiltersType = {
      ...paginationFilters,
      pageSize,
      page: 1,
    };

    changePageSize(pageSize);
    updateSearchUrlParams({ [FILTERS.pagination]: updatedFilters });
  };

  const handleSortingChange = (sorting: string): void => {
    const updatedFilters: PaginationFiltersType = {
      ...paginationFilters,
      sorting,
      page: 1,
    };

    changeSorting(sorting);
    updateSearchUrlParams({ [FILTERS.pagination]: updatedFilters });
  };

  return { paginationFilters, handlePaginationPageChange, handlePageSizeChange, handleSortingChange };
};
